<template>
    <div>
        <!-- Modal -->
        <div id="templateNameModal" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">
                            Template Name
                        </h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @keydown="templateForm.errors.clear($event.target.name)">
                            <div class="mb-2">
                                <div class="form-group">
                                    <input v-model="templateForm.template_name" class="form-control"
                                           :class="{'border-red': templateForm.errors.has('template_name')}" type="text"
                                           id="template_name">
                                </div>
                                <div class="text-red text-xs" v-if="templateForm.errors.has('template_name')">
                                    {{ templateForm.errors.get('template_name') }}
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button id="save-as-template" name="save-as-template"
                                @click.prevent="saveAsTemplate"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex justify-between mb-4 items-start">
            <div class="flex items-baseline">
            </div>
            <div class="flex items-start w-1/2">
                <button @click="applyTemplate" class="btn btn-outline-secondary rounded-full mr-2 whitespace-no-wrap">
                    Apply Template
                </button>
                <multiselect class="mr-2"
                             id="templates"
                             v-model="selectedTemplate"
                             :options="allTemplates"
                             :multiple="false"
                             :close-on-select="true"
                             :clear-on-select="false"
                             :preserve-search="false"
                             :taggable="false"
                             open-direction="below"
                             placeholder="Pick a Template"
                             :showLabels="false"
                             label="template_name"
                             track-by="id"
                             :preselect-first="false">
                </multiselect>
            </div>
        </div>
        <div class="card bg-white shadow">
            <div class="card-body">
                <div class="form-group">
                    <label for="disclaimer" class="font-bold tracking-wide">Disclaimer</label>
                    <input v-model="tempSection.disclaimer" type="text" class="form-control" id="disclaimer" @input="saveAuthorization">
                </div>
            </div>
        </div>
        <div class="card bg-white shadow">
            <div class="card-body">
                <div class="form-group mb-4">
                    <label class="mr-2 font-bold tracking-wide" for="section">Section Title</label>
                    <input v-model="tempSection.section.title" type="text" class="form-control" id="section" @input="saveAuthorization">
                </div>
                <div class="flex font-bold mb-4 tracking-wide">
                    <div class="col-1"></div>
                    <div class="col-4">Item</div>
                    <div class="col-2">Quantity</div>
                    <div class="col-2">Price</div>
                    <div class="col-2">Line Total</div>
                    <div class="col-1"></div>
                </div>
                <draggable v-model="tempSection.section.items" @change="handleSubitemOrderChange">
                    <transition-group>
                        <div v-for="(item, itemIndex) in tempSection.section.items"
                             :key="item.uniqueIdentifier"
                             class="cursor-pointer flex mb-4">
                            <div class="col-1">
                                <span class="material-icons">drag_indicator</span>
                            </div>
                            <div class="col-4">
                                    <textarea v-model="item.title"
                                              class="form-control non-resizeable"></textarea>
                            </div>
                            <div class="col-2">
                                <input v-model="item.quantity" type="number" class="form-control">
                            </div>
                            <div class="col-2">
                                <input v-model="item.price" type="number" class="form-control">
                            </div>
                            <div class="col-2">
                                <div>${{ computeTotal(item) }}</div>
                            </div>
                            <div class="col-1">
                                    <span @click="deleteItem(itemIndex)"
                                          class="material-icons text-red cursor-pointer">delete</span>
                            </div>
                        </div>
                    </transition-group>
                </draggable>
                <div class="flex mt-4 col">
                    <button @click="addItem" class="btn btn-outline-secondary rounded-full flex">
                        <span class="material-icons">add</span>
                        Add Item
                    </button>
                </div>
            </div>
        </div>
        <div class="card bg-white shadow">
            <div class="card-body">
                <div class="row mb-4">
                    <div class="col-6 font-bold tracking-wide">Product</div>
                    <div class="col-6 font-bold tracking-wide">Selection <span
                        class="font-light text-xs tracking-normal">(Can be left blank)</span></div>
                </div>
                <div v-for="productAndSelection in tempSection.product_and_selections" :key="productAndSelection.id"
                     class="row">
                    <div class="form-group col-6">
                        <input v-model="productAndSelection.product" type="text" class="form-control">
                    </div>
                    <div class="form-group col-6">
                        <input v-model="productAndSelection.selection" type="text" class="form-control">
                    </div>
                </div>
            </div>
        </div>
        <div class="card bg-white shadow">
            <div class="card-body">
                <div class="form-group">
                    <label for="footer_notes" class="font-bold tracking-wide">Footer Notes</label>
                    <textarea v-model="tempSection.footer_notes" name="footer_notes" id="footer_notes"
                              class="form-control" @input="saveAuthorization"></textarea>
                </div>
            </div>
            <div class="card-footer">
                <button v-if="!templateForm.is_template" @click="openSaveAsTemplateModal"
                        class="btn btn-outline-secondary rounded-full">
                    Save as Template
                </button>
                <button v-else @click="removeAsTemplate" class="btn btn-outline-danger rounded-full">
                    Remove as Template
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import Form from "../../utils/form";
    import QuillContainer from '../shared/quill-container';
    import draggable from 'vuedraggable';
    import Multiselect from 'vue-multiselect';

    export default {
        props: ['section'],
        components: {QuillContainer, draggable, Multiselect},
        data() {
            return {
                tempSection: {
                    uniqueIdentifier: this.section.uniqueIdentifier,
                    id: this.section.id,
                    proposal_id: this.section.proposal_id,
                    name: this.section.name,
                    include_in_report: this.section.include_in_report,
                    order: this.section.order,
                    tag: this.section.tag,
                    deleteable: this.section.deleteable,
                    disclaimer: this.section.disclaimer,
                    section: this.section.section,
                    sub_custom: this.section.sub_custom,
                    product_and_selections: this.section.product_and_selections,
                    footer_notes: this.section.footer_notes,
                },
                editName: false,
                templateForm: new Form({
                    template_name: this.section.template_name,
                    is_template: this.section.is_template,
                }),
                selectedTemplate: null,
                allTemplates: this.section.all_templates,
            }
        },
        methods: {
            handleSubitemOrderChange(event) {
                if (event.moved) {
                    let oldIndex = event.moved.oldIndex;
                    let newIndex = event.moved.newIndex;
                    this.tempSection.section.items[newIndex].order = newIndex;
                    if (newIndex < oldIndex) {
                        for (let i = newIndex + 1; i <= oldIndex; i++) {
                            this.tempSection.section.items[i].order++;
                        }
                    } else {
                        for (let i = oldIndex; i < newIndex; i++) {
                            this.tempSection.section.items[i].order--;
                        }
                    }
                }
            },
            computeTotal(item) {
                return item.quantity * item.price;
            },
            addItem() {
                let item = {
                    uniqueIdentifier: 'subitem-' + Math.random().toString(36).substring(2),
                    title: null,
                    quantity: 0,
                    price: 0,
                    order: this.tempSection.section.items.length,
                };
                this.tempSection.section.items.push(item);
                this.saveAuthorization();
            },
            deleteItem(itemIndex) {
                this.tempSection.section.items.splice(itemIndex, 1);
            },
            saveAuthorization() {
                this.$emit('authorizationChanged', this.tempSection);
            },
            openSaveAsTemplateModal() {
                $("#templateNameModal").modal("show");
            },
            saveAsTemplate() {
                this.templateForm.is_template = 1;
                this.templateForm.put('/proposal-generator/authorization/' + this.tempSection.id + '/template')
                    .then((data) => {
                        if (data.status === 'success') {
                            $("#templateNameModal").modal("hide");
                        }
                    });
            },
            removeAsTemplate() {
                this.templateForm.template_name = null;
                this.templateForm.is_template = 0;
                this.templateForm.put('/proposal-generator/authorization/' + this.tempSection.id + '/template');
            },
            applyTemplate() {
                if (this.selectedTemplate) {
                    this.tempSection.name = this.selectedTemplate.name;
                    this.tempSection.disclaimer = this.selectedTemplate.disclaimer;
                    this.tempSection.footer_notes = this.selectedTemplate.footer_notes;

                    this.tempSection.section.title = this.selectedTemplate.section.title;
                    this.tempSection.section.items = this.selectedTemplate.section.items;
                    let self = this;
                    this.tempSection.section.items.forEach(item => delete item.id);
                    this.tempSection.product_and_selections.forEach((item, index) => {
                        item.product = self.selectedTemplate.product_and_selections[index].product;
                        item.selection = self.selectedTemplate.product_and_selections[index].selection;
                    });
                }
            },
        }
    }
</script>

<style scoped>
    .non-resizeable {
        resize: none;
    }
</style>
